import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Api from '../../services/Api';
import { ApiResponse } from 'apisauce';
import {
  service,
  factories,
  models,
  IEmbedConfiguration,
  Embed,
} from 'powerbi-client';
import './PowerBiReport.css';
import { UserInfo } from '../Login/common/defaults';
import { Button } from 'react-bootstrap';
import ExportButton from './ExportButton';

export interface IPowerBiEditReportProps {
  viewMode: models.ViewMode;
  reportId?: string;
  history: any;
  currentUser: UserInfo;
}

const powerbi = new service.Service(
  factories.hpmFactory,
  factories.wpmpFactory,
  factories.routerFactory
);

class PowerBiEditReport extends React.Component<IPowerBiEditReportProps> {
  reportRef: React.Ref<HTMLDivElement>;
  reportContainer: HTMLElement;
  loading: JSX.Element;
  constructor(props: IPowerBiEditReportProps) {
    super(props);

    this.state = { accessToken: '', embedUrl: '', error: [] };

    this.reportRef = React.createRef();

    // Report container
    this.loading = (
      <div
        id={'reportContainer'} // + this.props.containerId}
        ref={this.reportRef}
        className='reportContainer'
      >
        Loading the report...
      </div>
    );
  }

  report: Embed;

  doeEmbed = () => {
    if (this.reportRef !== null) {
      this.reportContainer = this.reportRef['current'];
    }

    Api.get(`PBI/GetEmbedParam?reportId=${this.props.reportId}`).then(
      (result: ApiResponse<any>) => {
        //const embedData = $.parseJSON(result.data);
        const embedData = result.data;
        const reportLoadConfig = {
          type: 'report',
          tokenType: models.TokenType.Embed,
          accessToken: embedData.accessToken,
          embedUrl: embedData.embedUrl,
          permissions: models.Permissions.All /*gives maximum permissions*/,
          viewMode: models.ViewMode.View,
          /*
                // Enable this setting to remove gray shoulders from embedded report
                settings: {
                    background: models.BackgroundType.Transparent
                }
                */
        };

        // Use the token expiry to regenerate Embed token for seamless end user experience
        // Refer https://aka.ms/RefreshEmbedToken
        const tokenExpiry = embedData.embedTokenExpiry;

        // Embed Power BI report when Access token and Embed URL are available
        this.report = powerbi.embed(this.reportContainer, reportLoadConfig);

        // Clear any other loaded handler events
        this.report.off('loaded');

        // Triggers when a report schema is successfully loaded
        this.report.on('loaded', function () {
          console.log('Report load successful');
        });

        // Clear any other rendered handler events
        this.report.off('rendered');

        // Triggers when a report is successfully embedded in UI
        this.report.on('rendered', (e) => {
          console.log('Report render successful');
        });

        // Clear any other error handler events
        this.report.off('error');

        // Handle embed errors
        this.report.on('error', function (event) {
          var errorMsg = event.detail;

          // Use errorMsg variable to log error in any destination of choice
          console.error(errorMsg);
          return;
        });
      }
    );
  };

  componentDidMount() {
    if (this.reportRef !== null) {
      this.reportContainer = this.reportRef['current'];
    }
  }
  // React function
  componentWillUnmount(): void {
    powerbi.reset(this.reportContainer);
  }

  printReport = () => {
    (this.report as any)?.print();
  }

  getBookmarkState = async () => {
    const bookmark = await (this.report as any).bookmarksManager.capture();
    return bookmark.state;
  }

  public render() {
    this.doeEmbed();
    return (
      <>
        {this.loading}
        <hr />
        <ExportButton reportId={this.props.reportId} getBookmarkState={this.getBookmarkState} />
      </>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PowerBiEditReport)
);
